<template>
  <div
    class="md-layout activity-info-card"
    :class="{'display-column': displayColumn, 'selected': selected}"
  >
    <div class=" item">
      <img :src="activity.image">
    </div>
    <div class="details">
      <div class="title">
        <span>{{ activity.title }}</span>
      </div>
      <div class="value">
        <span>{{ activity.value }}</span>
        <span class="parameter">  {{ activity.parameter }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityInfo',
  props: ['activity', 'displayColumn', 'selected'],
}
</script>

<style lang="scss">

  .activity-info-card {
    display: flex;
    align-content: center;
    background: #F6F6F6;
    height: 72px;
    .details {
      display: flex;
      flex-direction: column;
      width: calc(100% - 45px);
      justify-content: center;
      .title {
        font-size: 14px;
        font-weight: 400;
        color: #8C7272;
        margin: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap
      }
      .value {
        font-size: 20px;
        font-weight: 500;
        .parameter {
          font-weight: 200;
          font-size: 14px;
        }
      }
    }
    .item {
      display: flex;
      height: 100%;
      width: 45px;
      justify-content: center;
      align-items: center;
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
  .display-column {
    height: 105px !important;
    flex-direction: column;
    justify-content: center;
    .item {
      height: auto;
      width: auto;
      margin-bottom: 5px;
    }
    &.selected {
      background: #EDEDED;
    }
  }

</style>